import React from "react";
// import { CiCircleCheck } from "react-icons/ci";

import './Sidebar.scss'

const Sidebar = () => {

	const handleScrollToContact = () => {
		const section = document.getElementById("contact-section");

		if (section) {
			section.scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		}
	};

	return (
		<aside className="sidebar">

			<div className="booking-card">

				<p>👨‍👩‍👧 Up to 8 People* | ⏰ Flexible Check-in</p>
				{/* <p>⏰ Flexible Check-in</p> */}

				<div className="sidebar-price">
					₹4,000*<span>/day</span>
				</div>

				<div className="utilities-text">
					{/* <p>👨‍👩‍👧 Up to 8 People*</p> */}
					{/* <p>⏰ Flexible Check-in</p> */}
					<p>🕒 Check-in: <strong>11:00 AM</strong></p>
					<p>🕙 Check-out: <strong>06.00 PM</strong></p>
				</div>


				<div className="sidebar-price">
					₹5,000*<span>/night</span>
				</div>

				<div className="utilities-text">

					{/* <p>⏰ Flexible Check-in</p> */}
					<p>🕒 Check-in: <strong>08:00 PM</strong></p>
					<p>🕙 Check-out: <strong>09:00 AM</strong></p>
				</div>

				<div className="button-group">
					<button className="btn-primary-large" onClick={handleScrollToContact}>
						Check Availability
					</button>

					<a className="contact-owner-btn" href="tel:9049928292">
						Call Now
					</a>
				</div>

				<div className="agent-profile">
					<img
						src="https://lh3.googleusercontent.com/aida-public/AB6AXuAW7AOfhaOnSNpCpBKdApfI2eLnJrbLZnjxtyLMJz6XoI8kcAD8l0n0v946uo9BHSBFruAaTP9MOlzExMSHs6eTi5ESzvU5norxPyWzfrJxjMxOlxkUzvpXOAIwX7Ts9QK2UmFwgiOy7IBhz2kwQNgGTh9oR54W-zGQwsxnVjE1yYledShJl3MMvw96h0Jv3XGat_JYtyjMepYGpk77oZTLDQx-DAsg7YcSysXzDKN-EnTF0ji1cqu5oQLuxpbu3GjF-nrrl4C8E_M"
						alt="owner"
					/>

					<div>
						<p className="agent-name">Nikit Alagi</p>

						<a
							href="tel:+919049928292"
							className="agent-call"
						>
							📞 +91 9049928292
						</a>
					</div>
				</div>

			</div>

		</aside>
	);
};

export default Sidebar;